import { DeviceClientActionCategory } from '@/types/device'

type EdgeClientAction = 'update' | 'restart'

const CATEGORY_MESSAGE_IDS: Partial<
  Record<DeviceClientActionCategory, string>
> = {
  device_offline: 'devices.edgeClient.error.deviceOffline',
  device_rejected: 'devices.edgeClient.error.deviceRejected',
  download_failed: 'devices.edgeClient.error.downloadFailed',
  checksum_failed: 'devices.edgeClient.error.checksumFailed',
  insufficient_disk_space: 'devices.edgeClient.error.insufficientDiskSpace',
  incompatible_environment: 'devices.edgeClient.error.incompatibleEnvironment',
  service_start_failed: 'devices.edgeClient.error.serviceStartFailed',
  installer_error: 'devices.edgeClient.error.installerError',
  timeout: 'devices.edgeClient.error.timeout'
}

export const getEdgeClientErrorCategoryMessageId = (
  category: DeviceClientActionCategory
): string | undefined =>
  Object.prototype.hasOwnProperty.call(CATEGORY_MESSAGE_IDS, category)
    ? CATEGORY_MESSAGE_IDS[category]
    : undefined

export const getEdgeClientFallbackMessageId = (
  action: EdgeClientAction | null
): string =>
  action === 'restart'
    ? 'devices.edgeClient.restart.error'
    : 'devices.edgeClient.update.error'
